import { type ReactNode } from "react";
import { motion } from "framer-motion";
import { Radio } from "lucide-react";

/**
 * Moldura das telas públicas (entrar, recuperar senha, criar conta).
 *
 * Duas colunas: o formulário à esquerda, a marca do cliente à direita. A
 * coluna da marca some no celular — é identidade, não conteúdo.
 */
export function Entrada({ marca, logo, children }: {
  marca: string; logo?: string | null; children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen">
      <div className="flex w-full items-center justify-center px-5 py-10 lg:w-1/2">
        {/* Sem opacidade na entrada: formulário que nasce invisível e não
            recebe o quadro da animação fica invisível de vez. Já aconteceu
            com os indicadores do painel. */}
        <motion.div initial={{ y: 10 }} animate={{ y: 0 }}
                    transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                    className="w-full max-w-[400px]">
          {children}
        </motion.div>
      </div>

      <div className="relative hidden w-1/2 items-center justify-center overflow-hidden lg:flex"
           style={{ background: "var(--color-brand-950, #161950)" }} aria-hidden>
        <GradeDeFundo />
        <div className="relative z-10 flex max-w-sm flex-col items-center text-center">
          {logo
            ? <img src={logo} alt="" className="mb-6 h-12 max-w-[260px] object-contain" />
            : (
              <span className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl"
                    style={{ background: "var(--color-brand-tenant)" }}>
                <Radio size={30} strokeWidth={2} className="text-white" />
              </span>
            )}
          <p className="text-2xl font-semibold text-white">{marca}</p>
          <p className="mt-3 text-sm leading-relaxed text-white/60">
            Rastreamento em tempo real, histórico de 45 dias e relatórios da frota,
            no navegador ou no celular.
          </p>
        </div>
      </div>
    </div>
  );
}

/** Malha discreta ao fundo, como no TailAdmin: textura, não desenho. */
function GradeDeFundo() {
  return (
    <svg className="absolute inset-0 h-full w-full opacity-[0.16]" aria-hidden>
      <defs>
        <pattern id="grade" width="56" height="56" patternUnits="userSpaceOnUse">
          <path d="M56 0H0V56" fill="none" stroke="white" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grade)" />
    </svg>
  );
}

export function Campo({ label, value, onChange, obrigatorio, ajuda, ...p }: {
  label: string; value: string; onChange: (v: string) => void;
  obrigatorio?: boolean; ajuda?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value">) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-medium text-ink-700 dark:text-ink-200">
        {label}
        {obrigatorio && <span className="ml-0.5 text-[var(--color-critical)]">*</span>}
      </span>
      <input {...p} value={value} onChange={e => onChange(e.target.value)} className="campo" />
      {ajuda && <span className="mt-1.5 block text-xs text-ink-500">{ajuda}</span>}
    </label>
  );
}
